module.exports = __webpack_public_path__ + "img/course.74233cab.png";